import React, { Component, Suspense, lazy } from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router';

import LayoutPrincipal from './pages/Layout/LayoutPrincipal';
import LayoutAuth from './pages/Layout/LayoutAuth';
import PaginaNaoExiste from './pages/PaginaNaoExiste';

import Loader from './components/ui/loader';

import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';

import LoginPage from './pages/Login/LoginPage';
import EsqueciSenhaPage from './pages/Login/EsqueciSenhaPage';
import RotasService, { rotasPermitidas } from './service/RotasService';
import RotaProfundaGuard from './pages/Layout/RotaProfundaGuard';

// Rota pública (link mágico do cliente final / relatório) — lazy-loaded de propósito, e SEM
// LayoutPrincipal/LayoutAuth: não deve carregar o bundle do painel admin (PrimeReact/EntityGrid/
// jsPDF/xlsx) nem exigir login antes do cliente medir a própria banda (ver plano de migração,
// Fase 3.3/3.4). Componente real vem na Fase 3.3 — isto ainda é só o esqueleto de rota.
const Monitoramento = lazy(() => import('./pages/Monitoramento'));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissoes: {},
    };
  }

  componentDidMount() {
    window.addEventListener('showToast', (event) => {
      this.refs.toast.show(event.detail);
    });
    window.addEventListener('hideToast', (event) => {
      this.refs.toast.hide(event.detail);
    });
  }

  render() {
    const permitidos = rotasPermitidas(this.state.permissoes);
    this.router = createBrowserRouter([
      // Rota pública, sem layout nenhum
      {
        path: '/monitoramento/:id',
        element: (
          <Suspense fallback={null}>
            <Monitoramento />
          </Suspense>
        ),
      },
      // Rotas públicas de autenticação (sem token)
      {
        element: <LayoutPrincipal />,
        children: [
          {
            path: '/login',
            element: <LoginPage setPermissoes={(permissoes, cb) => this.setState({ permissoes }, cb)} />,
          },
          {
            path: '/esqueci-senha',
            element: <EsqueciSenhaPage />,
          },
          {
            path: '/*',
            element: <PaginaNaoExiste />,
          },
        ],
      },
      // Rotas administrativas (exigem token em localStorage["auth"])
      {
        element: <LayoutAuth permissoes={this.state.permissoes} />,
        children: [
          ...Object.entries(permitidos).map(([key, cfg]) => ({
            path: cfg.rota + '/*',
            element: <RotaProfundaGuard
              cfg={cfg}
              controllerKeyAtual={key}
              rotaRegistry={RotasService}
              permissoes={this.state.permissoes}
              getRouter={() => this.router}
            />,
          })),
        ],
      },
    ]);
    return (
      <>
        <RouterProvider router={this.router} />
        <Loader inicializarVisivel={false} />
        <ConfirmDialog />
        <Toast ref={(ref) => this.refs.toast = ref} />
      </>
    );
  }
}
export default App;
